<template>

  <main id="renew2_login">
    <div class="login_container">
      <div class="renew2_wrapper renew2_flex">
        <div class="login_contents">
          <div class="renew2_flex lead">
            <h2>무료회원가입</h2>
          </div>
          <p>Yagish의<a href="/kr/resume/terms" id="footer-link-terms" target="_blank">이용약관</a>,<a
              href="/kr/resume/privacy" class="" id="footer-link-terms" target="_blank">개인정보 취급에 대하여</a>에 동의하신 후 로그인
            해주세요.</p>
          <register-forms />
        </div>
      </div>
    </div>
  </main>

</template>
<style lang="css" src="@/assets/css/renew_reset.css"></style>
<style lang="css" src="@/assets/css/renew2_style.css"></style>
<style lang="css" src="@/assets/css/renew2_login.css"></style>

<script>
// import LoginForms from '@/components/RenewLoginForms'
import RegisterForms from '@/components/RegisterForms'
import firebase from 'firebase/app'
export default {
  components: {
    'register-forms': RegisterForms
  },
  data: function () {
    return {
      fullscreenLoading: true
    }
  },
  created: function () {
    console.log('created')
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        const urlParams = new URLSearchParams(window.location.search);
        var from_page = urlParams.get("frompage");
        if (from_page) {
          this.$router.push('/format/' + from_page + '/edit/output')
        } else {
          console.log('register go mypage')
          location.href = '/mypage'
          // //this.$router.push('/mypage')
        }
      }
      this.fullscreenLoading = false
    })
  },
  computed: {},
  mounted: function () {
  },
  methods: {},
  watch: {},
  mounted: function () { }
}
</script>
